'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import styles from '../styles/Home.module.css';

// CAS Meetings home. Rooms are created by CASS bookings — the join link lives
// in the confirmation email and calendar invite. Here a participant can
// re-join by pasting that link (or just its room code). No ad-hoc meeting
// creation: every room maps to a Meeting in CASS, and tokens are only minted
// for rooms the CASS app validates (see /api/connection-details proxy).
export default function HomePage() {
  const router = useRouter();
  const [value, setValue] = useState('');

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    const v = value.trim();
    if (!v) return;
    const code = v.includes('/rooms/')
      ? v.split('/rooms/')[1].split(/[?#]/)[0]
      : v.replace(/^\/+/, '').replace(/[/?#].*$/, '');
    if (code) router.push(`/rooms/${encodeURIComponent(code)}`);
  };

  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <h1 style={{ margin: 0 }}>CAS Meetings</h1>
        </div>
        <div className={styles.tabContent}>
          <p style={{ marginTop: 0 }}>
            Enter the meeting link or room code from your confirmation email.
          </p>
          <form onSubmit={onSubmit}>
            <input
              id="room"
              name="room"
              type="text"
              autoComplete="off"
              placeholder="Meeting link or room code"
              value={value}
              onChange={(ev) => setValue(ev.target.value)}
              required
              style={{ width: '100%' }}
            />
            <button
              className="lk-button"
              type="submit"
              style={{ marginTop: '1rem', paddingInline: '1.25rem', width: '100%' }}
            >
              Join meeting
            </button>
          </form>
          <p style={{ opacity: 0.6, fontSize: '0.85rem' }}>
            Meetings may include an AI notetaker — a transcript and summary are shared with the
            host.
          </p>
        </div>
      </main>
      <footer data-lk-theme="default">
        CAS Meetings — video built on{' '}
        <a href="https://github.com/livekit/components-js" rel="noopener">
          open-source&nbsp;LiveKit
        </a>
        .
      </footer>
    </>
  );
}
